import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../contexts/LanguageContext';
import { Icon } from "@iconify/react";

function Register() {
  const navigate = useNavigate();
  const { register, loginWithGoogle } = useAuth();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // 前端驗證
    if (formData.password !== formData.confirmPassword) {
      setError(t('errors.passwordMismatch'));
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError(t('errors.passwordTooShort'));
      setLoading(false);
      return;
    }

    const result = await register(formData.email, formData.password, formData.name);

    if (result.success) {
      setSuccess(result.message);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleGoogleLogin = async () => {
    // Basic implementation - clear previous errors
    setError("");
    setSuccess("");

    const result = await loginWithGoogle();

    if (result && result.success) {
      navigate("/projects");
    } else {
      if (result && result.message) {
        setError(result.message);
      }
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--bg-primary)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        padding: "2rem 1rem",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          background: "var(--bg-primary)",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
          maxWidth: "1000px",
          width: "100%",
          minHeight: "700px",
          border: "5px solid #fff",
        }}
      >
        {/* Left Side - Purple Gradient */}
        <div
          style={{
            flex: 1,
            background:
              "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
            padding: "3rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            color: "var(--text-primary)",
            position: "relative",
            borderRadius: "24px",
          }}
        >
          <div>
            <p
              style={{
                fontSize: "0.9rem",
                opacity: 0.9,
                marginBottom: "1rem",
                fontWeight: "400",
              }}
            >
              {t('auth.joinUsToday')}
            </p>
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                lineHeight: "1.2",
                margin: "0 0 2rem 0",
              }}
            >
              {t('auth.createYourAccount')}
              <br />
              {t('auth.andGetStarted')}
            </h1>
          </div>

          {/* Features Section */}
          <div>
            <p
              style={{
                fontSize: "0.9rem",
                opacity: 0.8,
                marginBottom: "1.5rem",
                fontWeight: "400",
              }}
            >
              {t('auth.whatYouWillGet')}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <div
                style={{
                  opacity: 0.9,
                  fontSize: "1rem",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                }}
              >
                <Icon icon="mdi:check-circle" width="20" height="20" />
                {t('auth.aiPoweredContent')}
              </div>
              <div
                style={{
                  opacity: 0.9,
                  fontSize: "1rem",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                }}
              >
                <Icon icon="mdi:check-circle" width="20" height="20" />
                {t('auth.multiPlatformPublishing')}
              </div>
              <div
                style={{
                  opacity: 0.9,
                  fontSize: "1rem",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                }}
              >
                <Icon icon="mdi:check-circle" width="20" height="20" />
                {t('auth.advancedAnalytics')}
              </div>
              <div
                style={{
                  opacity: 0.9,
                  fontSize: "1rem",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                }}
              >
                <Icon icon="mdi:check-circle" width="20" height="20" />
                {t('auth.customerSupport24')}
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Register Form */}
        <div
          style={{
            flex: 1,
            padding: "3rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "450px",
            minHeight: "690px",
            overflowY: "auto",
          }}
        >
          <div style={{ marginBottom: "2rem" }}>
            <h2
              style={{
                fontSize: "1.8rem",
                fontWeight: "700",
                color: "#1f2937",
                marginBottom: "0.5rem",
                margin: "0",
              }}
            >
              {t('auth.registerViralArc')}
            </h2>
            <p
              style={{
                color: "#6b7280",
                fontSize: "0.9rem",
                margin: "0.5rem 0 0 0",
              }}
            >
              {t('auth.createAccountStart')}
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div
                style={{
                  background: "var(--bg-primary)",
                  color: "#374151",
                  padding: "0.75rem",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                  fontSize: "0.85rem",
                }}
              >
                {error}
              </div>
            )}

            {success && (
              <div
                style={{
                  background: "var(--bg-primary)",
                  color: "#6b7280",
                  padding: "0.75rem",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                  fontSize: "0.85rem",
                }}
              >
                {success} - {t('auth.redirectToLogin')}
              </div>
            )}

            {/* Name Field */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "500",
                  marginBottom: "0.5rem",
                  color: "#374151",
                  fontSize: "0.85rem",
                }}
              >
                {t('auth.name')} <span style={{ color: "#374151" }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder={t('auth.enterName')}
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "0.75rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                  background: "var(--bg-primary)",
                  color: "#374151",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Email Field */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "500",
                  marginBottom: "0.5rem",
                  color: "#374151",
                  fontSize: "0.85rem",
                }}
              >
                Email <span style={{ color: "#374151" }}>*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder={t('auth.enterEmail')}
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "0.75rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                  background: "var(--bg-primary)",
                  color: "#374151",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Password Field */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "500",
                  marginBottom: "0.5rem",
                  color: "#374151",
                  fontSize: "0.85rem",
                }}
              >
                {t('auth.password')} <span style={{ color: "#374151" }}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder={t('auth.enterPassword')}
                  value={formData.password}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: "0.75rem",
                    paddingRight: "3rem",
                    border: "1px solid #d1d5db",
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    background: "var(--bg-primary)",
                    color: "#374151",
                    boxSizing: "border-box",
                  }}
                />
                <div
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6b7280",
                    display: "flex",
                    userSelect: "none",
                    transition: "color 0.2s ease",
                  }}
                >
                  <Icon
                    icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
                    width="20"
                    height="20"
                  />
                </div>
              </div>
            </div>

            {/* Confirm Password Field */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "500",
                  marginBottom: "0.5rem",
                  color: "#374151",
                  fontSize: "0.85rem",
                }}
              >
                {t('auth.confirmPassword')} <span style={{ color: "#374151" }}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder={t('auth.enterPasswordAgain')}
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: "0.75rem",
                    paddingRight: "3rem",
                    border: "1px solid #d1d5db",
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    background: "var(--bg-primary)",
                    color: "#374151",
                    boxSizing: "border-box",
                  }}
                />
                <div
                  onClick={toggleConfirmPasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6b7280",
                    display: "flex",
                    userSelect: "none",
                    transition: "color 0.2s ease",
                  }}
                >
                  <Icon
                    icon={showConfirmPassword ? "mdi:eye-off" : "mdi:eye"}
                    width="20"
                    height="20"
                  />
                </div>
              </div>
            </div>

            {/* Register Button */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                background: loading ? "#9ca3af" : "#667eea",
                border: "none",
                color: "var(--text-primary)",
                padding: "0.75rem",
                borderRadius: "8px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: loading ? "not-allowed" : "pointer",
                marginBottom: "1.5rem",
                transition: "all 0.2s ease",
                userSelect: "none",
              }}
            >
              {loading ? t('auth.registering') : t('auth.register')}
            </button>

            {/* Login link */}
            <div
              style={{
                textAlign: "center",
                fontSize: "0.85rem",
                marginBottom: "1.5rem",
              }}
            >
              <span style={{ color: "#6b7280" }}>{t('auth.alreadyHaveAccount')}</span>
              <Link
                to="/login"
                style={{
                  color: "#667eea",
                  textDecoration: "none",
                  fontWeight: "600",
                  marginLeft: "0.5rem",
                }}
              >
                {t('auth.loginNow')}
              </Link>
            </div>

            {/* Divider */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1.5rem",
              }}
            >
              <div
                style={{
                  flex: 1,
                  height: "1px",
                  background: "var(--bg-primary)",
                }}
              ></div>
              <span
                style={{
                  padding: "0 1rem",
                  color: "#6b7280",
                  fontSize: "0.85rem",
                }}
              >
                {t('auth.or')}
              </span>
              <div
                style={{
                  flex: 1,
                  height: "1px",
                  background: "var(--bg-primary)",
                }}
              ></div>
            </div>

            {/* Social RegisterButtons */}
            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexDirection: "column",
              }}
            >
              <button
                type="button"
                onClick={handleGoogleLogin}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  width: "100%",
                  padding: "0.75rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  background: "var(--bg-primary)",
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  color: "#374151",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                }}
              >
                <Icon icon="devicon:google" width="18" height="18" />
                {t('auth.registerWithGoogle')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;